import { fg } from '@atlaskit/platform-feature-flags';

// This function is used to get the feature flags that should be passed down to Forge Custom UI apps
export const getPlatformFeatureFlags = (): string[] => {
	const platformFeatureFlags: string[] = [];
	// Add feature flags that are required to be passed down to the iframe
	// EXAMPLE:
	// if (fg(<flag-name>)) {
	// 	platformFeatureFlags.push(<flag-name>);
	// }

	if (fg('forge-ui-app-perf-tracking-enabled')) {
		platformFeatureFlags.push('forge-ui-iframe-analytics');
	}
	if (fg('forge-ui-bridge-core-reset')) {
		platformFeatureFlags.push('forge-ui-bridge-core-reset');
	}
	// TODO: clean up later when Forge CDN repo is ready
	platformFeatureFlags.push('forge-ui-iframe-ufo-perf-observers');
	if (fg('platform-dst-lozenge-tag-badge-visual-uplifts')) {
		platformFeatureFlags.push('platform-dst-lozenge-tag-badge-visual-uplifts');
	}
	if (fg('platform-dst-shape-theme-default')) {
		platformFeatureFlags.push('platform-dst-shape-theme-default');
	}
	if (fg('platform-dst-motion-uplift-popup')) {
		platformFeatureFlags.push('platform-dst-motion-uplift-popup');
	}
	if (fg('platform-dst-motion-uplift-modal')) {
		platformFeatureFlags.push('platform-dst-motion-uplift-modal');
	}
	if (fg('platform-dst-motion-uplift-spotlight')) {
		platformFeatureFlags.push('platform-dst-motion-uplift-spotlight');
	}
	if (fg('platform-dst-motion-uplift')) {
		platformFeatureFlags.push('platform-dst-motion-uplift');
	}
	if (fg('platform-dst-motion-theme-default')) {
		platformFeatureFlags.push('platform-dst-motion-theme-default');
	}

	return platformFeatureFlags;
};
